import {IConnectCombinedState, connectTopLevelSelector} from '../connectCombinedState';
import {createSelector} from '@ngrx/store';
export const selectProfileState = createSelector(
    connectTopLevelSelector,
    (state: IConnectCombinedState) => state.profile
);
